import { http } from 'helpers/httpv2';

const URL_V2 = process.env.REACT_APP_API_V2;
const okrList = 'okr/find?page=1&page_size=1000&filter[okr_type]=northstar_objective&filter[assignment_as]=objective';
const addOkr = 'okr/create';
const editOkr = 'okr/update';
const allList = 'okr/find?page=1&page_size=1000&filter[okr_type]=northstar_objective';
const detailOkr = 'okr/detail/';
const addAssignment = 'okr/assignment';
const delAssignment = 'okr/assignment';
const addComment = 'okr/comment';
const listMeasurenment = 'okr/measurement?page=1&page_size=1000';
const listProcess = 'process';
const keyresultList = 'okr/find?page=1&page_size=1000&filter[okr_type]=northstar_objective&filter[assignment_as]=key_result';
const initiativeList = 'okr/find?page=1&page_size=1000&filter[okr_type]=northstar_objective&filter[assignment_as]=initiative';
const hierarchy = 'okr/hierarchy/';
const okrListDepartment = 'okr/find?page=1&page_size=1000&filter[okr_type]=northstar_objective&filter[assignment_type]=department';
const okrListTeam = 'okr/find?page=1&page_size=1000&filter[okr_type]=northstar_objective&filter[assignment_type]=team';
const okrStatus = 'okr/status?page=1&page_size=1000';
const updateProgress = 'okr/set-progress';
const duplicateOkr = 'okr/duplicate/';
const deleteOkr = 'okr/detail/';

export const apiOkrList = async (val) => {
  const datas = await http.get(`${URL_V2 + okrList}`);
  return datas.data.data;
};

export const apiAllList = async (val) => {
  let url = `${URL_V2 + allList}&filter[status]=active`;
  if (val === 'employee') {
    url = `${URL_V2 + allList}&filter[myokr]=true&filter[status]=active`;
  } else if (val !== undefined) {
    url = `${URL_V2 + allList}&filter[status]=active${val}`;
  }

  const datas = await http.get(`${url}`);
  return datas.data.data;
};

export const apiAddOkr = async (val) => {
  const datas = await http.post(`${URL_V2 + addOkr}`, val);
  return datas.data.data;
};

export const apiEditOkr = async (val) => {
  const datas = await http.patch(`${URL_V2 + editOkr}`, val);
  return datas.data.data;
};

export const apiDetailOkr = async (id) => {
  const datas = await http.get(`${URL_V2 + detailOkr + id}`);
  return datas.data.data;
};

export const apiAssignment = async (val) => {
  const datas = await http.post(`${URL_V2 + addAssignment}`, val);
  return datas.data.data;
};
export const apiDelAssignment = async (val) => {
  const datas = await http.delete(`${URL_V2 + delAssignment}`, {
    data: val,
  });
  return datas.data.data;
};
export const apiPtComment = async (val) => {
  const datas = await http.post(`${URL_V2 + addComment}`, val);
  return datas.data.data;
};
export const apiListMeasurenment = async (val) => {
  const datas = await http.get(`${URL_V2 + listMeasurenment}`);
  return datas.data.data;
};
export const apiListProcess = async (val) => {
  let queryParams = '?page=1&page_size=100';
  if (val) {
    queryParams = val;
  }
  const datas = await http.get(`${URL_V2 + listProcess + queryParams}`);
  return datas.data.data;
};
export const apiKeyresultList = async (val) => {
  const datas = await http.get(`${URL_V2 + keyresultList + val}`);
  return datas.data.data;
};
export const apiInitiativeList = async (val) => {
  const datas = await http.get(`${URL_V2 + initiativeList}`);
  return datas.data.data;
};
export const apiPtHierarchy = async (val) => {
  const datas = await http.get(`${URL_V2 + hierarchy + val}`);
  return datas.data.data;
};
export const apiOkrListTeam = async (val) => {
  const datas = await http.get(`${URL_V2 + okrListTeam}`);
  return datas.data.data;
};
export const apiOkrListDepartmen = async (val) => {
  const datas = await http.get(`${URL_V2 + okrListDepartment}`);
  return datas.data.data;
};

export const apiOkrStatus = async (val = '') => {
  const datas = await http.get(`${URL_V2 + okrStatus}`);
  return datas.data.data;
};

export const apiUpdateProgress = async (val) => {
  const datas = await http.post(`${URL_V2 + updateProgress}`, val);
  return datas.data.data;
};

export const apiDuplicateOkr = async (val) => {
  const datas = await http.post(`${URL_V2 + duplicateOkr + val}`);
  return datas.data.data;
};

export const apiDeleteOkr = async (val) => {
  const datas = await http.delete(`${URL_V2 + deleteOkr + val}`);
  return datas.data.data;
};
